import { render, staticRenderFns } from "./ReceivableStatement.vue?vue&type=template&id=5e4eb8bf&scoped=true"
import script from "./ReceivableStatement.vue?vue&type=script&lang=ts"
export * from "./ReceivableStatement.vue?vue&type=script&lang=ts"
import style0 from "./ReceivableStatement.vue?vue&type=style&index=0&id=5e4eb8bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4eb8bf",
  null
  
)

export default component.exports